export default "/_next/static/chunks/fonts/fangsong_GB2312-cdc7d66d78675cf58dc3e3807f7564ef.ttf";